// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TDeleteDocumentRequestPayload,
  TDeleteDocumentResponsePayload,
  TDownloadDocumentRequestPayload,
  TDownloadDocumentResponsePayload,
  TGetMarkdownRequestPayload,
  TGetMarkdownResponsePayload,
  TListDocumentsRequestPayload,
  TListDocumentsResponsePayload,
  TReviewGeneratedTagsRequestPayload,
  TReviewGeneratedTagsResponsePayload,
  TUpdateDocumentRequestPayload,
  TUpdateDocumentResponsePayload,
  TUpdateMarkdownRequestPayload,
  TUpdateMarkdownResponsePayload,
  TUploadDocumentRequest,
  TUploadDocumentResponsePayload,
} from './document-navigator.types.ts';

export const createDocumentNavigatorApi = (transport: TApiTransport) => ({
  /** Deletes a document */
  deleteDocument: (
    payload: TDeleteDocumentRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDeleteDocumentRequestPayload,
      TDeleteDocumentResponsePayload
    >('/delete_document', payload, options),

  /** Downloads a document */
  downloadDocument: (
    payload: TDownloadDocumentRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TDownloadDocumentRequestPayload,
      TDownloadDocumentResponsePayload
    >('/download_document', payload, options),

  /** Returns a document's markdown */
  getMarkdown: (
    payload: TGetMarkdownRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TGetMarkdownRequestPayload, TGetMarkdownResponsePayload>(
      '/get_markdown',
      payload,
      options,
    ),

  /** Lists documents */
  listDocuments: (
    payload: TListDocumentsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TListDocumentsRequestPayload, TListDocumentsResponsePayload>(
      '/list_documents',
      payload,
      options,
    ),

  /** Reviews a document's generated tags */
  reviewGeneratedTags: (
    payload: TReviewGeneratedTagsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TReviewGeneratedTagsRequestPayload,
      TReviewGeneratedTagsResponsePayload
    >('/review_generated_tags', payload, options),

  /** Updates a document */
  updateDocument: (
    payload: TUpdateDocumentRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateDocumentRequestPayload,
      TUpdateDocumentResponsePayload
    >('/update_document', payload, options),

  /** Updates a document's markdown */
  updateMarkdown: (
    payload: TUpdateMarkdownRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TUpdateMarkdownRequestPayload,
      TUpdateMarkdownResponsePayload
    >('/update_markdown', payload, options),

  /** Uploads a document */
  uploadDocument: (
    payload: TUploadDocumentRequest,
    options?: TApiRequestOptions,
  ) =>
    transport.post<TUploadDocumentRequest, TUploadDocumentResponsePayload>(
      '/upload_document',
      payload,
      { ...options, contentType: 'multipart/form-data' },
    ),
});
